module.exports = __webpack_public_path__ + "static/media/kahe-logo-1.e7ddf81c.png";